module.exports = __webpack_public_path__ + "static/img/shop2.1d44b506.png";